import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Divider, Grid, Stack, Typography } from '@mui/material';

import FormProvider from 'common/components/form-provider';
import React from 'react';
import { useForm } from 'react-hook-form';
import { colors, styleInput } from 'common/constants';
import BaseTextField from 'common/components/base-text-field';
import { createStyleSheet, handleError } from 'utils/helpers';
import { eInvoiceSchema } from 'common/schema';
import { RootState } from 'plugins/store';
import { useAppDispatch, useAppSelector } from 'common/hook';
import { CheckPricePayment } from 'services/payment.service';
import { setSurveyPaymentInvoiceInfo } from 'slices/paymentSlice';
import { toast } from 'react-toastify';
interface IElectronicInvoiceProps {
    tabIndex: number;
    setActiveStep: (index: number) => void;
}
const ElectronicInvoice: React.FC<IElectronicInvoiceProps> = ({
    setActiveStep,
}) => {
    const surveyPayment = useAppSelector(
        (state: RootState) => state.payment.surveyPayment
    );
    console.log(surveyPayment);
    const dispatch = useAppDispatch();
    const methods = useForm({
        resolver: yupResolver(eInvoiceSchema),
        defaultValues: {
            companyName: surveyPayment.invoiceInfo.companyName,
            taxCode: surveyPayment.invoiceInfo.taxCode,
            address: surveyPayment.invoiceInfo.address,
            invoiceRecipient: surveyPayment.invoiceInfo.invoiceRecipient,
            phone: surveyPayment.invoiceInfo.phone,
            email: surveyPayment.invoiceInfo.email,
        },
        mode: 'onChange',
    });
    const { handleSubmit } = methods;

    const onSubmit = handleSubmit(async (data) => {
        console.log(surveyPayment);
        if (!surveyPayment.product_id) {
            toast.error('Hãy hoàn thành bước 1 trước');
            return;
        }
        try {
            const payment_target_payload = {
                dob: surveyPayment.payment_target.dob,
                gender: surveyPayment.payment_target.gender,
                address: surveyPayment.payment_target.address,
                marriage: surveyPayment.payment_target.marriage,
                child: surveyPayment.payment_target.child,
                career: surveyPayment.payment_target.career,
                career_field: surveyPayment.payment_target.career_field,
                monthly_personal_income:
                    surveyPayment.payment_target.monthly_personal_income,
                monthly_family_income:
                    surveyPayment.payment_target.monthly_family_income,
            };
            const payload = {
                payment: {
                    product_type: surveyPayment.product_type,
                    product_id:
                        surveyPayment.product_type === 'Plan'
                            ? surveyPayment.product_id
                            : surveyPayment.campaign?.value,
                    total_answer: surveyPayment.costInfo.number_of_answer,
                    client_id: surveyPayment.client_id,
                    client_company_name: data.companyName,
                    client_tax_number: data.taxCode,
                    client_company_address: data.address,
                    client_name: data.invoiceRecipient,
                    client_phone: data.phone,
                    client_email: data.email,
                    payment_target: payment_target_payload,
                },
            };
            const response = await CheckPricePayment(payload);
            if (response.success) {
                const responseAttributes = response.data.payment.attributes;
                if (responseAttributes) {
                    dispatch(
                        setSurveyPaymentInvoiceInfo({
                            companyName: responseAttributes.client_company_name,
                            taxCode: responseAttributes.client_tax_number,
                            address: responseAttributes.client_company_address,
                            invoiceRecipient: responseAttributes.client_name,
                            phone: responseAttributes.client_phone,
                            email: responseAttributes.client_email,
                        })
                    );
                }
                setActiveStep(2);
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            handleError(error);
        }
    });

    return (
        <Box sx={{ mt: 3, mb: 3 }}>
            <FormProvider methods={methods} onSubmit={onSubmit}>
                <Grid container spacing={11}>
                    <Grid item xs={7}>
                        <Typography
                            variant="h5"
                            sx={{
                                fontWeight: 600,
                                fontSize: '30px',
                                lineHeight: '36px',
                                marginBottom: '26px',
                            }}
                        >
                            Hóa đơn điện tử
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: '20px',
                                lineHeight: '24.2px',
                                marginBottom: '26px',
                            }}
                        >
                            Hóa đơn điện tử sẽ được gửi về{' '}
                            <b>Email nhận hóa đơn điện tử</b> sau khi thanh toán
                            thành công
                        </Typography>
                        <Stack spacing={5}>
                            <BaseTextField
                                name="companyName"
                                placeholder="Tên doanh nghiệp"
                                sx={styles.input}
                                InputProps={{
                                    inputProps: {
                                        maxLength: 255,
                                    },
                                }}
                            />
                            <BaseTextField
                                name="taxCode"
                                placeholder="Mã số thuế"
                                sx={styles.input}
                                InputProps={{
                                    inputProps: {
                                        maxLength: 55,
                                    },
                                }}
                            />
                            <BaseTextField
                                name="address"
                                placeholder="Địa chỉ doanh nghiệp"
                                sx={styles.input}
                                InputProps={{
                                    inputProps: {
                                        maxLength: 255,
                                    },
                                }}
                            />
                            <BaseTextField
                                name="invoiceRecipient"
                                placeholder="Tên người nhận hóa đơn"
                                sx={styles.input}
                                InputProps={{
                                    inputProps: {
                                        maxLength: 255,
                                    },
                                }}
                            />
                            <BaseTextField
                                name="email"
                                placeholder="Email nhận hóa đơn điện tử"
                                sx={styles.input}
                            />
                            <BaseTextField
                                name="phone"
                                placeholder="Số điện thoại"
                                type="phone"
                                sx={styles.input}
                                InputProps={{
                                    inputProps: {
                                        maxLength: 20,
                                    },
                                }}
                            />
                        </Stack>
                    </Grid>
                    {surveyPayment.package === 'Plan' ? (
                        <Grid item xs={5}>
                            <Typography
                                variant="h5"
                                sx={{
                                    fontWeight: 700,
                                    fontSize: '30px',
                                    lineHeight: '60.51px',
                                }}
                            >
                                Hóa đơn
                            </Typography>
                            <Divider
                                sx={{
                                    borderTop: '2px dashed #000',
                                    margin: '20px 0px 30px 0px',
                                }}
                            />
                            <Typography
                                variant="h4"
                                sx={{
                                    fontSize: '40px',
                                    fontWeight: 600,
                                    lineHeight: '35px',
                                    marginBottom: '12px',
                                }}
                            >
                                {surveyPayment.costInfo.total_price_text}
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    fontSize: '24px',
                                    lineHeight: '35px',
                                    fontWeight: 400,
                                    marginBottom: '43px',
                                }}
                            >
                                Tổng chi phí VND
                            </Typography>
                            <Box>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    sx={{
                                        width: '100%',
                                        marginBottom: '39px',
                                        minHeight: '60px',
                                        borderRadius: '60px',
                                        fontSize: '24px',
                                        textTransform: 'none',
                                        fontWeight: 700,
                                    }}
                                >
                                    Xác nhận
                                </Button>
                            </Box>
                            {surveyPayment.costInfo.total_price ? (
                                <>
                                    <Box>
                                        <Typography
                                            variant="h5"
                                            sx={{
                                                fontSize: '30px',
                                                fontWeight: 600,
                                                lineHeight: '25px',
                                                marginBottom: '12px',
                                            }}
                                        >
                                            Ngày hoàn thành
                                        </Typography>
                                        <Typography
                                            variant="h6"
                                            sx={{
                                                fontSize: '18.46px',
                                                fontWeight: 400,
                                                lineHeight: '18.46px',
                                                marginBottom: '59px',
                                                color: '#000000B2',
                                            }}
                                        >
                                            {
                                                surveyPayment.costInfo
                                                    .date_payment
                                            }
                                        </Typography>
                                    </Box>
                                    <Typography
                                        variant="h5"
                                        sx={{
                                            fontSize: '30px',
                                            fontWeight: 600,
                                            lineHeight: '25px',
                                            marginBottom: '24px',
                                        }}
                                    >
                                        Chi tiết
                                    </Typography>
                                    <Box
                                        sx={{
                                            display: 'grid',
                                            gridTemplateColumns:
                                                'repeat(2, 1fr)',
                                            gap: 3,
                                        }}
                                    >
                                        {[
                                            {
                                                label: 'Tổng tiền',
                                                value: surveyPayment.costInfo
                                                    .base_price_text,
                                            },
                                            {
                                                label: 'Chiết khấu',
                                                value: surveyPayment.costInfo
                                                    .discount_text,
                                            },
                                            {
                                                label: 'Tổng chi phí trước thuế',
                                                value: surveyPayment.costInfo
                                                    .price_before_tax_text,
                                            },
                                            {
                                                label: 'VAT (10%)',
                                                value: surveyPayment.costInfo
                                                    .tax_text,
                                            },
                                        ].map((item, index) => (
                                            <React.Fragment key={index}>
                                                <Box
                                                    sx={{
                                                        fontSize: '24px',
                                                        fontWeight: 400,
                                                        lineHeight: '29.05px',
                                                        color: '#000000B2',
                                                    }}
                                                >
                                                    {item.label}
                                                </Box>
                                                <Box
                                                    sx={{
                                                        fontSize: '24px',
                                                        fontWeight: 400,
                                                        lineHeight: '29.05px',
                                                        color: '#000000B2',
                                                        textAlign: 'right',
                                                    }}
                                                >
                                                    {item.value}
                                                </Box>
                                            </React.Fragment>
                                        ))}
                                    </Box>
                                </>
                            ) : (
                                ''
                            )}
                        </Grid>
                    ) : (
                        <Grid item xs={5}>
                            <Typography
                                variant="h5"
                                sx={{
                                    fontWeight: 700,
                                    fontSize: '30px',
                                    lineHeight: '60.51px',
                                }}
                            >
                                Hóa đơn
                            </Typography>
                            <Divider
                                sx={{
                                    borderTop: '2px dashed #000',
                                    margin: '20px 0px 30px 0px',
                                }}
                            />
                            <Typography
                                variant="h4"
                                sx={{
                                    fontSize: '40px',
                                    fontWeight: 600,
                                    lineHeight: '35px',
                                    marginBottom: '12px',
                                }}
                            >
                                {surveyPayment.costInfo.total_price_text}
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    fontSize: '24px',
                                    lineHeight: '35px',
                                    fontWeight: 400,
                                    marginBottom: '43px',
                                }}
                            >
                                Tổng chi phí VND
                            </Typography>
                            <Box>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    sx={{
                                        width: '100%',
                                        marginBottom: '39px',
                                        minHeight: '60px',
                                        borderRadius: '60px',
                                        fontSize: '24px',
                                        textTransform: 'none',
                                        fontWeight: 700,
                                    }}
                                >
                                    Xác nhận
                                </Button>
                            </Box>
                            <Box>
                                <Typography
                                    variant="h5"
                                    sx={{
                                        fontSize: '30px',
                                        fontWeight: 600,
                                        lineHeight: '25px',
                                        marginBottom: '12px',
                                    }}
                                >
                                    Ngày hoàn thành
                                </Typography>
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontSize: '18.46px',
                                        fontWeight: 400,
                                        lineHeight: '18.46px',
                                        marginBottom: '59px',
                                        color: '#000000B2',
                                    }}
                                >
                                    {surveyPayment.costInfo.date_payment}
                                </Typography>
                            </Box>
                            <Box
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(2, 1fr)',
                                    gap: 2,
                                }}
                            >
                                <Typography
                                    variant="h5"
                                    sx={{
                                        fontSize: '30px',
                                        fontWeight: 600,
                                        lineHeight: '25px',
                                        marginBottom: '24px',
                                    }}
                                >
                                    Chi tiết
                                </Typography>
                                <Box />

                                {[
                                    {
                                        label: 'Số lượng câu hỏi',
                                        value: surveyPayment.costInfo
                                            .number_of_question,
                                        icon: '1',
                                    },
                                    {
                                        label: 'Chi phí một câu hỏi',
                                        value: `${surveyPayment.costInfo.base_price_text} VND`,
                                        icon: '2',
                                    },
                                    {
                                        label: 'Số người tham gia',
                                        value: surveyPayment.costInfo
                                            .number_of_answer,
                                        icon: '3',
                                    },
                                ].map((item, index) => (
                                    <React.Fragment key={index}>
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                fontSize: '24px',
                                                fontWeight: 400,
                                                lineHeight: '29.05px',
                                                color: '#000000B2',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 1,
                                            }}
                                        >
                                            {item.label}
                                            {item.icon && (
                                                <Box
                                                    sx={{
                                                        width: '20px',
                                                        height: '20px',
                                                        backgroundColor:
                                                            colors.main,
                                                        fontSize: '12px',
                                                        color: '#fff',
                                                        borderRadius: '50%',
                                                        display: 'flex',
                                                        justifyContent:
                                                            'center',
                                                        alignItems: 'center',
                                                        fontWeight: 700,
                                                    }}
                                                >
                                                    {item.icon}
                                                </Box>
                                            )}
                                        </Typography>
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                fontSize: '24px',
                                                fontWeight: 400,
                                                lineHeight: '29.05px',
                                                textAlign: 'right',
                                                color: '#000000B2',
                                            }}
                                        >
                                            {item.value}
                                        </Typography>
                                    </React.Fragment>
                                ))}
                            </Box>

                            <Divider
                                sx={{
                                    borderTop: '2px dashed #000',
                                    margin: '20px 0px 51px 0px',
                                }}
                            />
                            <Box
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(2, 1fr)',
                                    gap: 2,
                                }}
                            >
                                <Box></Box>
                                <Box
                                    sx={{
                                        fontSize: '24px',
                                        fontWeight: 400,
                                        lineHeight: '29.05px',
                                        color: '#000000B2',
                                        textAlign: 'right',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'flex-end',
                                        gap: 1,
                                    }}
                                >
                                    Chi phí =
                                    {[1, 2, 3].map((item, index) => (
                                        <Box
                                            key={index}
                                            sx={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: 1,
                                            }}
                                        >
                                            <Box
                                                key={index}
                                                sx={{
                                                    width: '20px',
                                                    height: '20px',
                                                    backgroundColor:
                                                        colors.main,
                                                    fontSize: '12px',
                                                    color: '#fff',
                                                    borderRadius: '50%',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    fontWeight: 700,
                                                }}
                                            >
                                                {item}
                                            </Box>
                                            {index < [1, 2, 3].length - 1 && (
                                                <span
                                                    style={{
                                                        fontSize: '12px',
                                                        fontWeight: 400,
                                                    }}
                                                >
                                                    {' '}
                                                    X
                                                </span>
                                            )}
                                        </Box>
                                    ))}
                                </Box>
                                {[
                                    {
                                        label: 'Tổng tiền',
                                        value: `${surveyPayment.costInfo.price_before_discount_text} VND`,
                                    },
                                    {
                                        label: 'Chiết khấu',
                                        value: `${surveyPayment.costInfo.discount_text} VND`,
                                    },
                                    {
                                        label: 'Tổng chi phí trước thuế',
                                        value: `${surveyPayment.costInfo.price_before_tax_text} VND`,
                                    },
                                    {
                                        label: 'VAT (10%)',
                                        value: `${surveyPayment.costInfo.tax_text} VND`,
                                    },
                                ].map((item, index) => (
                                    <React.Fragment key={index}>
                                        <Box
                                            sx={{
                                                fontSize: '24px',
                                                fontWeight: 400,
                                                lineHeight: '29.05px',
                                                color: '#000000B2',
                                            }}
                                        >
                                            {item.label}
                                        </Box>
                                        <Box
                                            sx={{
                                                fontSize: '24px',
                                                fontWeight: 400,
                                                lineHeight: '29.05px',
                                                color: '#000000B2',
                                                textAlign: 'right',
                                            }}
                                        >
                                            {item.value}
                                        </Box>
                                    </React.Fragment>
                                ))}
                            </Box>
                        </Grid>
                    )}
                </Grid>
            </FormProvider>
        </Box>
    );
};
const styles = createStyleSheet({
    input: {
        '& .MuiInputBase-root': {
            ...styleInput['& .MuiInputBase-root'],
            height: '70px',
            fontSize: '22px',
            '& fieldset': {
                border: 'none',
            },
        },
    },
});
export default ElectronicInvoice;
